// 静态全局对象
const config = {
  title: 'e互助风控系统',
  api_base_url: homePath()
}

function homePath() {
  if (window.location.href.indexOf('test-rm.ehuzhu.com') >= 0) {
    return 'https://test-rm.ehuzhu.com/app'
  } else if (window.location.href.indexOf('pre-rm.ehuzhu.com') >= 0) {
    return 'https://pre-rm.ehuzhu.com/app'
  } else {
    return 'https://rm.ehuzhu.com/app'
  }
}

export { config }
